import type { Lang } from '../lib/api';

/**
 * Текст страницы «О проекте».
 *
 * Лежит отдельно от вёрстки: поменять текст — значит поправить этот файл и
 * ничего больше. Каждый абзац — отдельная строка в массиве.
 *
 * Русский — исходник Гора. Английский и армянский — перевод, армянский
 * стоит показать носителю (задача про вординг в Notion).
 */

/** Фото Гора. Файл кладётся в apps/web/public/about/. Пока его нет, блок с фото просто не показывается */
export const ABOUT_PHOTO = '/about/gor.jpg';

export interface AboutContent {
  title: string;
  lede: string;
  photoAlt: string;
  paragraphs: string[];
}

export const ABOUT: Record<Lang, AboutContent> = {
  en: {
    title: 'About Vishap Tea',
    lede: "Hi, I'm Gor!",
    photoAlt: 'Gor, the founder of Vishap Tea',
    paragraphs: [
      "I'm a tea enthusiast, and I love searching for the best teas and finding them. This project grew out of my hobby. Its mission is to give as many people as possible access to high-quality tea at the best price.",
      "A vishap is a dragon-like creature from Armenian mythology. To me it's a symbol that runs through every human culture, a creature of all the elements at once. Just like tea: growing from the Earth, brewed in Water over Fire, with its aroma drifting through the Air.",
      "Modern tea culture is a unique phenomenon, created by millions of people around the world. Let's drink tea together!",
    ],
  },
  ru: {
    title: 'О проекте',
    lede: 'Привет, это Гор!',
    photoAlt: 'Гор, основатель Vishap Tea',
    paragraphs: [
      'Я чайный энтузиаст, и мне очень нравится искать и находить лучшие чаи. Этот проект — продолжение моего хобби. Его миссия — дать широкому кругу людей возможность получать высококачественные чаи с лучшим соотношением цены и качества.',
      'Вишап — драконоподобное существо из армянской мифологии. Для меня это символ, пронизывающий все человеческие культуры, и существо всех стихий одновременно. Как и чай: растущий из Земли, готовящийся в Воде на Огне, с ароматом, витающим в Воздухе.',
      'Современная чайная культура — уникальное явление, которое создают миллионы людей по всему миру. Давайте пить чай вместе!',
    ],
  },
  hy: {
    title: 'Նախագծի մասին',
    lede: 'Բարև, ես Գոռն եմ։',
    photoAlt: 'Գոռը՝ Vishap Tea-ի հիմնադիրը',
    paragraphs: [
      'Ես թեյի սիրահար եմ, և ինձ շատ է դուր գալիս փնտրել ու գտնել լավագույն թեյերը։ Այս նախագիծն իմ հոբբիի շարունակությունն է։ Նրա առաքելությունն է մարդկանց լայն շրջանակին հնարավորություն տալ ստանալ բարձրորակ թեյեր՝ գնի և որակի լավագույն հարաբերակցությամբ։',
      'Վիշապը հայկական դիցաբանության առասպելական էակ է։ Ինձ համար այն խորհրդանիշ է, որը թափանցում է բոլոր մարդկային մշակույթները, և միաժամանակ բոլոր տարերքների էակ։ Ինչպես թեյը՝ Հողից աճող, Ջրում՝ Կրակի վրա պատրաստվող, Օդում տարածվող բույրով։',
      'Ժամանակակից թեյի մշակույթը եզակի երևույթ է, որը ստեղծում են միլիոնավոր մարդիկ ամբողջ աշխարհում։ Եկե՛ք միասին թեյ խմենք։',
    ],
  },
};
